import React from 'react';
import { Icon } from '../../../../../../components/shared/Icon';

const NotSubmittedButton = () => {
  return <Icon className={'mx-2'} name={'rejectedInvoice'} />;
};

export default React.memo(NotSubmittedButton);
